import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";

export const InsightsCopilotButton: React.FC<{
  onClick: () => void;
  dataLoc?: string;
}> = ({ onClick, dataLoc = "ask-copilot-button" }) => (
  <Button
    dataLoc={dataLoc}
    iconLeft={faSparkles}
    size="sm"
    variant="primary"
    onClick={onClick}
  >
    Ask Copilot
  </Button>
);
